/**
 * The Cleared Folio — Site Enhancements
 * Back-to-top button behaviour
 */

(function () {
  'use strict';

  // ── Back to Top ────────────────────────────────────────────────────────────

  var btn = document.getElementById('tcf-back-to-top');
  if (!btn) return;

  var scrollThreshold = 400;
  var ticking = false;

  function updateButtonVisibility() {
    if (window.pageYOffset > scrollThreshold) {
      btn.classList.add('is-visible');
    } else {
      btn.classList.remove('is-visible');
    }
    ticking = false;
  }

  window.addEventListener('scroll', function () {
    if (!ticking) {
      window.requestAnimationFrame(updateButtonVisibility);
      ticking = true;
    }
  }, { passive: true });

  btn.addEventListener('click', function () {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });

})();
